@for (col of columns; track col) {  
  @switch (col.dataType) {
    @case (DataColumnType.TEXT) {
      <td [ngClass]="col.class">
        {{col?.getValue() ?? ''}}
      </td>
    }
    @case (DataColumnType.MONEY) {
      <td [ngClass]="col.class" class="text-right">
        {{ col?.getValue() ?? '' | currency:'COP':'symbol-narrow':'1.0-0' }}
      </td>
    }
    @case (DataColumnType.NUMBER) {
      <td class="text-center">
        {{ col?.getValue() ?? ''}}
      </td>
    }
    @case(DataColumnType.NONE){
      <td>
      </td>
    }
    @default {
      No Data Column
    }
  }

}